import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class VirtualUserSharedService {
  private subjectVirtualUserAddModal = new BehaviorSubject<string | null>(null);
  private subjectVirtualUserEditModal = new BehaviorSubject<any>(null);
  private subjectVirtualUserViewModal = new BehaviorSubject<any>(null);

  constructor() {}

  setSubjectVirtualUserAddModal(str: string | null) {
    this.subjectVirtualUserAddModal.next(str);
  }
  getSubjectVirtualUserAddModal(): Observable<string | null> {
    return this.subjectVirtualUserAddModal.asObservable();
  }

  setSubjectVirtualUserEditModal(str: any) {
    this.subjectVirtualUserEditModal.next(str);
  }
  getSubjectVirtualUserEditModal(): Observable<any> {
    return this.subjectVirtualUserEditModal.asObservable();
  }

  setSubjectVirtualUserViewModal(user: any) {
    this.subjectVirtualUserViewModal.next(user);
  }
  getSubjectVirtualUserViewModal(): Observable<any> {
    return this.subjectVirtualUserViewModal.asObservable();
  }
}
